import { ContentPage } from "../components/layout/ContentPage";
import { getLegalCopy } from "../data/legalPages";
import { useTranslation } from "../i18n";
import { createLocalizedMeta } from "../utils/routeMeta";

export const meta = createLocalizedMeta({
	title: locale => getLegalCopy(locale).privacy.metaTitle,
	description: locale => getLegalCopy(locale).privacy.metaDescription,
	path: "/privacy",
});

export default function PrivacyPage() {
	const { locale } = useTranslation();
	const copy = getLegalCopy(locale).privacy;

	return (
		<ContentPage title={copy.title} subtitle={copy.subtitle}>
			{copy.sections.map(section => (
				<section key={section.title}>
					<h2>{section.title}</h2>
					<p>{section.body}</p>
				</section>
			))}
		</ContentPage>
	);
}
